import { render, staticRenderFns } from "./birthday-message-info.vue?vue&type=template&id=f410e1d2&"
import script from "./birthday-message-info.vue?vue&type=script&lang=js&"
export * from "./birthday-message-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports